import { http } from '@noor/api';
import { env } from '@noor/config';
import {
  restaurantCategoryResponseSchema,
  restaurantCategorySchema,
  type CreateRestaurantCategoryInput,
  type RestaurantCategory,
  type UpdateRestaurantCategoryInput,
} from '../model/category';
import type { BusinessListFilter } from '../model/list-params';
import {
  fetchAllBusinessPages,
  normalizeBusinessList,
  unwrapDataPayload,
  type BusinessListResult,
} from './envelope';

const eatsBase = { baseURL: env.VITE_EATS_API_URL };

export const restaurantCategoryApi = {
  list(filter: BusinessListFilter): Promise<BusinessListResult<RestaurantCategory>> {
    return http
      .get<unknown>('/api/v1/admin/restaurant-categories', {
        ...eatsBase,
        query: {
          'pagination.limit': String(filter.limit),
          'pagination.offset': String(filter.offset),
        },
      })
      .then((raw) => normalizeBusinessList(raw, restaurantCategorySchema, filter));
  },

  listAll(): Promise<RestaurantCategory[]> {
    return fetchAllBusinessPages((filter) => restaurantCategoryApi.list(filter));
  },

  async create(input: CreateRestaurantCategoryInput): Promise<RestaurantCategory> {
    const raw = await http.post<unknown>(
      '/api/v1/admin/restaurant-categories',
      { name: input.name },
      eatsBase,
    );
    return restaurantCategoryResponseSchema.parse(unwrapDataPayload(raw))
      .restaurant_category;
  },

  async update(
    id: string,
    input: UpdateRestaurantCategoryInput,
  ): Promise<RestaurantCategory> {
    const raw = await http.patch<unknown>(
      `/api/v1/admin/restaurant-categories/${id}`,
      input,
      eatsBase,
    );
    return restaurantCategoryResponseSchema.parse(unwrapDataPayload(raw))
      .restaurant_category;
  },

  async remove(id: string): Promise<void> {
    await http.delete<unknown>(`/api/v1/admin/restaurant-categories/${id}`, eatsBase);
  },
};
